// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"567":"5cf6dbf7","833":"e2d2cff7"}[chunkId] + ".chunk.js";
};